/** @jsxImportSource react */
import type { SVGProps } from 'react';
const LegacyEmptyRene = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 140 140" {...props}>
    <path
      fill="#E2E4EA"
      d="M52.953 74.92a16.63 16.63 0 0 1 15.388-10.33h3.046c7.26 0 13.682 4.71 15.86 11.637l15.549 49.42H32.193z"
    />
    <path
      stroke="url(#LegacyEmptyRene_0)"
      strokeLinecap="round"
      d="M33.63 111.443c2.82-10.687 17.783-30.917 34.589-30.06s18.908 12.919 19.944 17.099"
    />
    <rect
      width={20.116}
      height={45.121}
      x={44.805}
      y={17.296}
      fill="#E2E4EA"
      rx={10.058}
      transform="rotate(-8.413 44.805 17.296)"
    />
    <path stroke="#1E2024" strokeLinecap="round" d="M48.177 19.708c-.825.937-2.331 3.867-1.761 8.094" />
    <rect
      width={20.116}
      height={45.121}
      x={75.319}
      y={16.197}
      fill="#E2E4EA"
      rx={10.058}
      transform="rotate(12.378 75.32 16.197)"
    />
    <path
      fill="#E2E4EA"
      d="M50.238 37.896h37.868V70.27c0 10.457-8.477 18.933-18.934 18.933s-18.934-8.476-18.934-18.933z"
    />
    <path stroke="#1E2024" strokeLinecap="round" d="M50.61 74.233c.26 2.3 1.972 7.677 6.742 10.795" />
    <ellipse cx={61.392} cy={59.833} fill="#CBCFD8" rx={8.608} ry={11.983} />
    <path fill="#1E2024" d="m60.822 56.783 4.76-2.586v8.121a2.38 2.38 0 1 1-4.76 0z" />
    <path
      stroke="#1E2024"
      strokeLinecap="round"
      d="M73.072 55.116c.493 1.194 2.956 2.959 6.967 3.499M66.257 52.7c-.493 1.496-2.956 3.705-6.967 4.381"
    />
    <path
      fill="#1E2024"
      d="m78.256 58.377-4.76-2.066v6.007a2.38 2.38 0 0 0 4.76 0zM62.43 82.406a4.03 4.03 0 0 1 3.362-3.972l6.808-1.142c3.048-.512 5.724 2.066 5.327 5.13a4.6 4.6 0 0 1-4.565 4.012H66.46a4.03 4.03 0 0 1-4.028-4.028"
    />
    <rect width={2.895} height={6.055} x={75.83} y={59.447} fill="#fff" rx={1.447} />
    <rect width={2.895} height={6.055} x={63.362} y={59.447} fill="#fff" rx={1.447} />
    <path fill="#E2E4EA" d="M26.248 125.648c0-6.118 4.96-11.078 11.077-11.078h9.013v11.078z" />
    <path stroke="#1E2024" strokeLinecap="round" d="M26.255 125.602c-.2-2.67.826-8.412 6.534-10.026" />
    <path fill="#E2E4EA" d="M112.097 125.648c0-6.118-4.96-11.078-11.078-11.078h-9.013v11.078z" />
    <rect width={22.629} height={22.629} x={102.031} y={86.435} fill="#CBCFD8" rx={5} />
    <rect width={16.327} height={16.327} x={105.183} y={89.585} fill="#E2E4EA" rx={2} />
    <rect width={1.844} height={4.209} x={110.232} y={95.644} fill="#6B7180" rx={0.922} />
    <rect width={1.844} height={4.209} x={114.616} y={95.644} fill="#6B7180" rx={0.922} />
    <path
      fill="#6B7180"
      d="M85.123 109.458h1.782v3.079a.89.89 0 1 1-1.782 0zM89.42 109.458h1.782v3.079a.89.89 0 1 1-1.781 0z"
    />
    <path fill="#CBCFD8" d="M82.411 104.059a5.752 5.752 0 1 1 11.504 0v1.853H82.41z" />
    <path
      fill="#CBCFD8"
      d="M80.278 106.953c0-.585.455-1.069 1.039-1.106l13.55-.86a1.11 1.11 0 0 1 1.18 1.106v3.151c0 .646-.55 1.155-1.195 1.105l-13.55-1.05a1.11 1.11 0 0 1-1.024-1.105z"
    />
    <path
      stroke="#1E2024"
      strokeLinecap="round"
      d="M82.255 105.814c.183-.137 6.741-.397 6.741-.397M93.224 125.387c1.449-3.473 1.739-10.054-6.32-10.962M46.055 125.387c-1.449-3.473-1.738-10.054 6.32-10.962M73.496 110.211l-4.4 10.419M67.7 114.338l2.098 10.96M88.49 50.252c-.147.406-.43 2.068-.378 5.467M15.34 125.648h109.32"
    />
    <defs>
      <linearGradient
        id="LegacyEmptyRene_0"
        x1={60.896}
        x2={30.277}
        y1={81.357}
        y2={112.397}
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
    </defs>
  </svg>
);
export default LegacyEmptyRene;
